import { formatDate, formatNome } from '@/utils/format'
import type { User } from '@/types/user'
function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

function readNameFromObject(value: unknown): string | null {
  if (!isRecord(value)) return null
  const name = value.name
  return typeof name === 'string' && name.trim() ? formatNome(name) : null
}

function readString(value: unknown): string | null {
  return typeof value === 'string' && value.trim() ? value : null
}

function getFirstAvailableName(user: User, candidates: string[]): string | null {
  const rawUser = user as Record<string, unknown>

  for (const candidate of candidates) {
    const direct = readString(rawUser[candidate])
    if (direct) return formatNome(direct)

    const fromObject = readNameFromObject(rawUser[candidate])
    if (fromObject) return fromObject
  }

  return null
}

export function getInfoUsuarioViewModel(user: User) {
  const displayName = formatNome(user.name || '')
  const initials = displayName
    .split(' ')
    .map(part => part[0])
    .join('')
    .slice(0, 2)

  const createdDateDisplay =
    user.createdDate && user.createdDate !== 'N/A' ? formatDate(user.createdDate) : 'Não informado'

  const createdByDisplay =
    getFirstAvailableName(user, [
      'createdByName',
      'creatorName',
      'nomeCriador',
      'created_by_name',
      'createdBy',
      'creator',
      'usuarioCriacao',
      'userCreatedBy',
    ]) ?? 'Não informado'

  const responsibleDisplay =
    getFirstAvailableName(user, [
      'responsibleName',
      'managerName',
      'ownerName',
      'nomeResponsavel',
      'nomeGerente',
      'responsavelName',
      'gerenteName',
      'owner',
      'responsible',
      'manager',
      'responsavel',
      'gerente',
    ]) ?? 'Não informado'

  return {
    displayName,
    initials,
    createdDateDisplay,
    createdByDisplay,
    responsibleDisplay,
    isCNPJ: Boolean(user.cnpj),
  }
}
